<nb-card class="model-full">
  <nb-card-header>Mover a histórico</nb-card-header>


  <nb-card-body nbSpinnerStatus="danger" nbSpinnerSize="large"
  nbSpinnerMessage="Guardando Entidad..." [nbSpinner]="loading">

    <div class="row">

      <div class="row">
        <div class="col-sm-6" >
          <div class="form-group">
            <label for="desde" class="label">Desde</label>
            <input [nbDatepicker]="datepickerfrom" type="text" nbInput fullWidth id="desde" name="desde" [(ngModel)]="snapshot.workingfrom" >
            <nb-datepicker #datepickerfrom format="yyyy/MM/dd"></nb-datepicker>
          </div>
        </div>
        <div class="col-sm-6" >
          <div class="form-group">
            <label for="hasta" class="label">Hasta</label>
            <input [nbDatepicker]="datepickerto" type="text" nbInput fullWidth id="hasta" name="hasta" [(ngModel)]="snapshot.workinguntil" >
            <nb-datepicker #datepickerto format="yyyy/MM/dd"></nb-datepicker>
          </div>
        </div>
        </div>


    </div>

  </nb-card-body>
  <nb-card-footer>
    <div class=" row ">
      <div class="col-6 text-left">

        <button nbButton status="primary" (click)="cerrar()"><nb-icon icon="arrow-back"></nb-icon>Cerrar</button>
      </div>

      <div class="col-md-6 text-right">
        <button nbButton status="primary" (click)="moverHistorico()"><nb-icon icon="save"></nb-icon>Confirmar</button>

      </div>
    </div>


  </nb-card-footer>
</nb-card>
